/**
 * Biveris Product Categories Block Frontend JavaScript
 */
import './frontend.css';

document.addEventListener('DOMContentLoaded', function() {
	// Initialize animations for product categories
	initProductCategoriesAnimations();
	
	// Initialize expandable categories
	initExpandableCategories();
	
	// Check for auto-expand category from URL parameter
	initAutoExpandCategory();
});

/**
 * Initialize animations for product categories
 */
function initProductCategoriesAnimations() {
	const containers = document.querySelectorAll('.biveris-product-categories-container');
	
	containers.forEach(container => {
		const animationType = container.dataset.animationType || 'fade-up';
		const animationDelay = parseFloat(container.dataset.animationDelay) || 0.2;
		
		// Set up intersection observer for animations
		const observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					// Animate container first
					setTimeout(() => {
						entry.target.classList.add('bpc-animate-in');
					}, 50);
					
					// Animate company logo section (if present)
					const companyLogoSection = entry.target.querySelector('.company-logo-section');
					if (companyLogoSection) {
						setTimeout(() => {
							companyLogoSection.classList.add('bpc-animate-in');
						}, 100);
					}
					
					// Animate section header (if no logo)
					const sectionHeader = entry.target.querySelector('.bpc-section-header');
					if (sectionHeader) {
						setTimeout(() => {
							sectionHeader.classList.add('bpc-animate-in');
						}, 100);
					}
					
					// Animate category items with staggered delay
					const categoryItems = entry.target.querySelectorAll('.bpc-category-item');
					categoryItems.forEach((item, index) => {
						setTimeout(() => {
							item.classList.add('bpc-animate-in');
						}, 200 + (index * 100));
					});
					
					// Animate see all button
					const seeAllSection = entry.target.querySelector('.bpc-see-all-section');
					if (seeAllSection) {
						setTimeout(() => {
							seeAllSection.classList.add('bpc-animate-in');
						}, 300 + (categoryItems.length * 100));
					}
					
					// Unobserve after animation
					observer.unobserve(entry.target);
				}
			});
		}, {
			threshold: 0.1,
			rootMargin: '0px 0px -50px 0px'
		});
		
		observer.observe(container);
	});
}

/**
 * Handle category item hover effects
 */
function initCategoryItemHoverEffects() {
	const categoryItems = document.querySelectorAll('.bpc-category-item');
	
	categoryItems.forEach(item => {
		const categoryContent = item.querySelector('.bpc-category-content');
		
		if (categoryContent) {
			categoryContent.addEventListener('mouseenter', function() {
				item.style.transform = 'translateY(-4px)';
			});
			
			categoryContent.addEventListener('mouseleave', function() {
				item.style.transform = 'translateY(0)';
			});
		}
	});
}

// Initialize hover effects
initCategoryItemHoverEffects();

/**
 * Initialize expandable categories functionality
 */
function initExpandableCategories() {
	const categoryItems = document.querySelectorAll('.bpc-category-item');
	
	categoryItems.forEach(item => {
		const categoryContent = item.querySelector('.bpc-category-content');
		const productsContainer = item.querySelector('.bpc-products-container');
		const expandIcon = item.querySelector('.bpc-expand-icon');
		
		if (categoryContent && productsContainer && expandIcon) {
			categoryContent.addEventListener('click', function(e) {
				e.preventDefault();
				
				// Toggle expanded state
				const isExpanded = productsContainer.classList.contains('bpc-expanded');
				
				if (isExpanded) {
					// Collapse
					productsContainer.classList.remove('bpc-expanded');
					expandIcon.textContent = '+';
					item.classList.remove('bpc-expanded');
				} else {
					// Expand
					productsContainer.classList.add('bpc-expanded');
					expandIcon.textContent = '−';
					item.classList.add('bpc-expanded');
				}
			});
		}
	});
}

/**
 * Initialize auto-expand category functionality based on URL parameter
 */
function initAutoExpandCategory() {
	const containers = document.querySelectorAll('.biveris-product-categories-container');
	
	containers.forEach(container => {
		const autoExpandCategoryId = container.dataset.autoExpandCategory;
		
		// Check if we have a category ID to auto-expand
		if (autoExpandCategoryId && autoExpandCategoryId !== 'null' && autoExpandCategoryId !== '') {
			// Find the category item with the matching ID
			const targetCategoryItem = container.querySelector(`[data-category-id="${autoExpandCategoryId}"]`);
			
			if (targetCategoryItem) {
				// Wait for animations to complete before auto-expanding
				setTimeout(() => {
					const productsContainer = targetCategoryItem.querySelector('.bpc-products-container');
					const expandIcon = targetCategoryItem.querySelector('.bpc-expand-icon');
					
					if (productsContainer && expandIcon) {
						// Expand the category
						productsContainer.classList.add('bpc-expanded');
						expandIcon.textContent = '−';
						targetCategoryItem.classList.add('bpc-expanded');
						
						// Scroll to the expanded category for better UX
						targetCategoryItem.scrollIntoView({
							behavior: 'smooth',
							block: 'center'
						});
					}
				}, 1000); // Wait 1 second for initial animations to complete
			}
		}
	});
}